import { createSlice } from "@reduxjs/toolkit";

const d = {
    type: 1,
    accountNo: '',
    from: '',
    to: '',
    cn: '',
    Account: [],
    LocationID: [],
    subAccountId: []
}

const ShipperAdviceSlice = createSlice({
    name: 'shipperAdviceData',
    initialState: {
        data: d,
        calltracks: [],
        reattempts: [],
        grid: [],
        originalGrid: [],
        fileLen: 0,
        fileName: '',
        fileType: null,
        uploadedGrid: [],
        uploadedGridStatus: []
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data
        },
        setCalltracks: (state, action) => {
            state.calltracks = action.payload.data
        },
        setReattempts: (state, action) => {
            state.reattempts = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        },
        setOriginalGrid: (state, action) => {
            state.originalGrid = action.payload.data
        },
        updateGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.grid[index][key] = val;
            if (key == 'reattemptReason' && val == 2) {
                state.grid[index]['consigneeContact'] = '';
                state.grid[index]['consigneeAddress'] = '';
            }

        },
        removeGridItem: (state, action) => {
            const index = action.payload.index;
            state.grid.splice(index, 1);
        },
        setFileLen: (state, action) => {
            state.fileLen = action.payload.data
        },
        setFileName: (state, action) => {
            state.fileName = action.payload.data
        },
        setFileType: (state, action) => {
            state.fileType = action.payload.data
        },
        reset: (state, action) => {
            state.data = d
        },
        setUploadedGrid: (state, action) => {
            state.uploadedGrid = action.payload.data
        },
        updateUploadedGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.uploadedGrid[index][key] = val;
            // if (key == 'reattemptReason' && val == 2) {
            //     state.uploadedGrid[index]['consigneeContact'] = '';
            //     state.uploadedGrid[index]['consigneeAddress'] = '';
            // }
        },
        setUploadedGridStatus: (state, action) => {
            state.uploadedGridStatus = action.payload.data
        },
    }
});

export default ShipperAdviceSlice.reducer;
export const { setData, setCalltracks, setReattempts, setGrid, setOriginalGrid, updateGrid, 
    removeGridItem, setFileLen, setFileName, setFileType, reset,
    setUploadedGrid, updateUploadedGrid, setUploadedGridStatus
} = ShipperAdviceSlice.actions;